<template>
    <FormGroup
        :name="name"
        :label="label"
        :as-row="asRow"
        :size="size"
        :required="required"
        :errors="errors"
        :hide-validation="!showValidation">
        <template #default>
            <select
                ref="input"
                v-model="model"
                class="form-control"
                :class="inputClass"
                :name="name"
                :required="required"
                v-bind="$attrs">
                <option :value="null">
                    {{ nullItemLabel }}
                </option>

                <optgroup v-if="required && options.length === 0" :label="emptyItemLabel" />

                <option
                    v-for="option in options"
                    :key="option[keyField]"
                    :value="option[keyField]">
                    {{ option[nameField] }}
                </option>
            </select>
        </template>

        <template #tips>
            <slot />
        </template>
    </FormGroup>
</template>

<script>
import FieldMixin from '@/js/mixins/FieldMixin';

import FormGroup from '@/js/components/common/fields/FormGroup';

export default {
    name: 'ComboField',

    components: {FormGroup},

    mixins: [FieldMixin],

    inheritAttrs: false,

    props: {
        value: {type: [String, Number], default: null},
        options: {type: Array, required: true},
        keyField: {type: String, default: 'id'},
        nameField: {type: String, default: 'name'},
        nullLabel: {type: String, default: null},
        emptyLabel: {type: String, default: null},
    },

    computed: {
        nullItemLabel() {
            return this.nullLabel || this.$t('common.placeholders.choose');
        },

        emptyItemLabel() {
            return this.emptyLabel || this.$t('common.placeholders.empty');
        },
    },

    methods: {
        parse(value) {
            return this.format(value);
        },

        format(value) {
            if ((value === null) || (value === undefined)) {
                return null;
            }

            if (this.options.findIndex((option) => value === option[this.keyField]) === -1) {
                return null;
            }

            return value;
        },
    },
};
</script>
